// extracted by mini-css-extract-plugin
export default {"inputsContainer":"styles_inputsContainer__DBQQ+","columnsContainer":"styles_columnsContainer__jhe29","topInputsContainer":"styles_topInputsContainer__T0w0Z"};